var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 5.21064V16.044M10 5.21064C9.02675 4.56404 7.70541 4.16666 6.25 4.16666C4.79459 4.16666 3.47325 4.56404 2.5 5.21064V16.044C3.47325 15.3974 4.79459 15 6.25 15C7.70541 15 9.02675 15.3974 10 16.044M10 5.21064C10.9732 4.56404 12.2946 4.16666 13.75 4.16666C15.2054 4.16666 16.5268 4.56404 17.5 5.21064V16.044C16.5268 15.3974 15.2054 15 13.75 15C12.2946 15 10.9732 15.3974 10 16.044",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookOpen);
export default __webpack_public_path__ + "static/media/bookOpen.bcdc92d2b96d108fffff91046db8ef55.svg";
export { ForwardRef as ReactComponent };